import AppFooter from "./AppFooter.vue";
import AppNavbar from "./AppNavbar.vue";
import AppInput from "./AppInput.vue";
import AuthTitle from "./AuthTitle.vue";
import AppButton from "./AppButton.vue";
import AuthRouters from "./AuthRouters.vue";
import SectionTitle from "./SectionTitle.vue";
import AppLoading from "./AppLoading.vue";


export default [
  AppFooter,
  AppNavbar,
  AppInput,
  AuthTitle,
  AppButton,
  AuthRouters,
  SectionTitle,
  AppLoading

]